import { FC, useCallback, ReactNode } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Grid,
  Typography,
  Button,
} from "@mui/material";
import { Close } from "@mui/icons-material";
import { translate } from "../../translate/translate";

interface DialogVersionProps {
  id: string;
  open: boolean;
  onClose: (result: boolean) => void;
  title: string;
  message: string;
  labelButtonCancel?: string;
  labelButton: string;
  colorButton?:
  | "primary"
  | "secondary"
  | "error"
  | "warning"
  | "info"
  | "success"
  | "inherit";
  children?: ReactNode;
}

const DialogVersion: FC<DialogVersionProps> = ({
  id,
  open,
  onClose,
  title,
  message,
  labelButtonCancel,
  labelButton,
  colorButton,
  children,
}) => {
  const handleCloseDialog = useCallback(
    (result: boolean) => {
      onClose(result);
    },
    [onClose]
  );

  return (
    <Dialog
      id={id}
      open={open}
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          display: "flex",
          flexDirection: "column",
          width: "fit-content",
          maxWidth: "95vw",
          maxHeight: "85vh",
        },
      }}
    >
      {/* Cabeçalho */}
      <Grid
        container
        justifyContent="space-between"
        alignItems="center"
        padding={2}
        sx={{ backgroundColor: "primary.main", flexShrink: 0 }}
      >
        <Typography
          sx={{ color: "#ffffff", fontWeight: "bold", fontSize: "16px" }}
        >
          {title}
        </Typography>
        <Close
          sx={{ cursor: "pointer", color: "#ffffff" }}
          onClick={() => handleCloseDialog(false)}
        />
      </Grid>

      {/* Corpo */}
      <DialogContent
        dividers
        sx={{
          flexGrow: 1,
          overflowY: "overlay",
          "&::-webkit-scrollbar": { display: "none" },
          msOverflowStyle: "none",
          scrollbarWidth: "none",
          padding: 2,
        }}
      >
        {/* Mensagem principal */}
        <Typography
          component="div"
          sx={{ whiteSpace: "nowrap", marginBottom: 2 }}
          dangerouslySetInnerHTML={{ __html: message }}
        />
        {children}
      </DialogContent>

      {/* Rodapé */}
      <DialogActions
        sx={{
          borderTop: "1px solid #E0E0E0",
          backgroundColor: "#FAFAFA",
          flexShrink: 0,
        }}
      >
        <Grid container justifyContent="flex-end" gap={1} padding={2}>
          <Button
            color="primary"
            variant="outlined"
            onClick={() => handleCloseDialog(false)}
          >
            {labelButtonCancel || translate.t("cancel")}
          </Button>
          <Button
            variant="contained"
            color={colorButton || "error"}
            onClick={() => handleCloseDialog(true)}
          >
            {labelButton}
          </Button>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default DialogVersion;
